const GRID_ROW_HEIGHT = 40;
const FIXED_HEIGHT_ROW_THRESHOLD = 30;
const SETTINGS_GRID_CHROME_HEIGHT = 200;
const SETTINGS_PAGE_CHROME_HEIGHT = 220;
const PACKAGE_ASSOCIATION_GRID_CHROME_HEIGHT = 240;
const PACKAGE_ASSOCIATION_PAGE_CHROME_HEIGHT = 260;

export const resolveSettingsListTotal = ({ items, metadata, status }) => {
    const itemCount = items?.length ?? 0;

    if (status?.loading || itemCount === 0) {
        return 0;
    }

    if (metadata?.hasMore === false) {
        return itemCount;
    }

    return metadata?.total ?? itemCount;
};

const listFitsViewport = (rowCount, gridChromeHeight, pageChromeHeight) => {
    if (rowCount === 0) {
        return false;
    }

    if (rowCount <= FIXED_HEIGHT_ROW_THRESHOLD) {
        return true;
    }

    const estimatedListHeight = rowCount * GRID_ROW_HEIGHT + gridChromeHeight;
    const availableHeight = window.innerHeight - pageChromeHeight;

    return estimatedListHeight <= availableHeight;
};

export const settingsListFitsViewport = (rowCount) =>
    listFitsViewport(rowCount, SETTINGS_GRID_CHROME_HEIGHT, SETTINGS_PAGE_CHROME_HEIGHT);

export const packageAssociationListFitsViewport = (rowCount) =>
    listFitsViewport(
        rowCount,
        PACKAGE_ASSOCIATION_GRID_CHROME_HEIGHT,
        PACKAGE_ASSOCIATION_PAGE_CHROME_HEIGHT,
    );

export const getSettingsPageSx = (useAutoHeight) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    ...(useAutoHeight
        ? {}
        : {
              flex: "1 1 0",
              height: "100%",
              minHeight: 0,
              overflow: "hidden",
          }),
});

export const getSettingsContentSx = (useAutoHeight) => ({
    padding: "0 !important",
    marginLeft: "24px",
    marginRight: "24px",
    width: "100%",
    boxSizing: "border-box",
    ...(useAutoHeight
        ? {}
        : {
              display: "flex",
              flex: "1 1 0",
              flexDirection: "column",
              height: "100%",
              minHeight: 0,
              overflow: "hidden",
              "& > #results": {
                  display: "flex",
                  flex: "1 1 0",
                  flexDirection: "column",
                  height: "100%",
                  minHeight: 0,
                  overflow: "hidden",
                  width: "100%",
              },
          }),
});

export const getSettingsGridModifiersSx = (useAutoHeight) => ({
    width: "100%",
    "& .MuiDataGrid-row": {
        cursor: "pointer",
    },
    "& .sovosPaginationFooter > :not(:first-child)": {
        display: "none",
    },
    ...(useAutoHeight
        ? {}
        : {
              display: "flex",
              flex: "1 1 0",
              flexDirection: "column",
              height: "100%",
              maxHeight: "100%",
              minHeight: 0,
              overflow: "hidden",
              "& .MuiDataGrid-root": {
                  display: "flex",
                  flex: "1 1 0",
                  flexDirection: "column",
                  minHeight: 0,
                  maxHeight: "100%",
                  overflow: "hidden",
              },
              "& .MuiDataGrid-mainContent": {
                  display: "flex",
                  flex: "1 1 0",
                  flexDirection: "column",
                  minHeight: 0,
                  overflow: "hidden",
              },
              "& .MuiDataGrid-main": {
                  flex: "1 1 0",
                  minHeight: 0,
                  overflow: "hidden",
              },
              "& .sovosPaginationFooter": {
                  flexShrink: 0,
                  marginTop: "auto",
              },
          }),
});
